module.exports = __webpack_public_path__ + "static/contact-c0e712d5183c8471c930ab771526dc0f.png";